import axios from 'axios';
import { baseUrl, token } from '../../../../services/Apis';

export const planevaActExtraEstudiantes = `${baseUrl}/actividad-extra-estudiantes`;

export const allActExtraEstudiantesService = async (params) => {
  const res = await axios.get(planevaActExtraEstudiantes, {
    headers: token({}),
    params,
  });
  return res;
};

export const saveActExtraEstudiantesService = async (id, data) => {
  let res;
  if (id) {
    res = await axios.patch(`${planevaActExtraEstudiantes}/${id}`, data, {
      headers: token({}),
    });
  } else {
    res = await axios.post(planevaActExtraEstudiantes, data, {
      headers: token({}),
    });
  }
  return res;
};

export const oneActExtraEstudiantesService = async (id) => {
  const res = await axios.get(`${planevaActExtraEstudiantes}/${id}`, {
    headers: token({}),
  });
  return res;
};

export const deleteActExtraEstudiantesService = async (id) => {
  const res = await axios.delete(`${planevaActExtraEstudiantes}/${id}`, {
    headers: token({}),
  });
  return res;
};
